import apiMiddleware from "../../../api/apiMiddleware";

// list countries with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `country?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

// create country
const create = async (countryData) => {
  // Create FormData object if countryData is not already a FormData instance
  const formData =
    countryData instanceof FormData ? countryData : new FormData();

  // If countryData is not FormData, append all properties to FormData
  if (!(countryData instanceof FormData)) {
    Object.keys(countryData).forEach((key) => {
      formData.append(key, countryData[key]);
    });
  }

  const response = await apiMiddleware.post("country", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// get country by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`country/${id}`);
  return response.data;
};

// update country
const update = async ({ id, countryData }) => {
  // Create FormData object if countryData is not already a FormData instance
  const formData =
    countryData instanceof FormData ? countryData : new FormData();

  // If countryData is not FormData, append all properties to FormData
  if (!(countryData instanceof FormData)) {
    Object.keys(countryData).forEach((key) => {
      formData.append(key, countryData[key]);
    });
  }

  const response = await apiMiddleware.post(
    `country/${id}?_method=put`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// delete country
const deleteCountry = async (id) => {
  const response = await apiMiddleware.delete(`country/${id}`);
  return response.data;
};

const sort = async ({ sort_from, sort_to }) => {
  const response = await apiMiddleware.post(`country-sort?_method=put`, {
    sort_from,
    sort_to,
  });
  return response.data;
};

export { list, create, getById, update, deleteCountry, sort };
